module.exports = __webpack_public_path__ + "static/media/apartment-geotiller.532d0c86.svg";